// Métricas de atendimento: formatação compartilhada pelas abas.
const BRL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export const brl = (n) => BRL.format(Number(n) || 0);

export const decimal = (n) => String(n ?? "—").replace(".", ",");

export const percent = (part, total) => {
  if (!total) return "—";
  return `${Math.round((part / total) * 100)}%`;
};

export const duration = (sec) => {
  if (sec === null || sec === undefined) return "—";
  const s = Math.round(Number(sec));
  if (s < 60) return `${s} s`;
  if (s < 3600) return `${Math.round(s / 60)} min`;
  const h = Math.floor(s / 3600);
  const m = Math.round((s % 3600) / 60);
  return m ? `${h} h ${m} min` : `${h} h`;
};

/** Comparação com o período anterior, no formato do StatCard; `lowerIsBetter` = subir é ruim (custo). */
export const trend = (now, before, lowerIsBetter = false) => {
  if (!before) return undefined;
  const value = Math.round(((now - before) / before) * 100);
  return { value, positive: lowerIsBetter ? value <= 0 : value >= 0 };
};

const HANDLED = { ai: "IA", bot: "Robô", human: "Equipe", mixed: "IA e equipe" };
export const handledByLabel = (k) => HANDLED[k] || k;

const TOPICS = {
  sem_internet: "Sem internet",
  lentidao: "Lentidão",
  instabilidade: "Instabilidade",
  wifi_senha: "Wi-Fi e senha",
  segunda_via: "2ª via de fatura",
  pagamento_comprovante: "Pagamento e comprovante",
  desbloqueio: "Desbloqueio",
  negociacao: "Negociação",
  mudanca_vencimento: "Mudança de vencimento",
  documentos: "Nota fiscal e contrato",
  visita_tecnica: "Visita técnica",
  hotspot_cartao: "Cartão de acesso Wi-Fi",
  falar_atendente: "Falar com atendente",
  sem_assunto: "Sem assunto",
  interno: "Conversa interna",
  mudanca_endereco: "Mudança de endereço",
  mudanca_plano: "Mudança de plano",
  instalacao: "Instalação",
  comercial: "Comercial",
  cancelamento: "Cancelamento",
  elogio: "Elogio",
  outro: "Outros",
  cotacao: "Cotação",
  disponibilidade: "Disponibilidade",
  reserva_andamento: "Reserva em andamento",
  pagamento: "Pagamento",
  check_in_out: "Check-in e check-out",
  regras_imovel: "Regras do imóvel",
  anfitriao: "Anfitrião",
  reclamacao: "Reclamação",
  duvida: "Dúvida",
  suporte: "Suporte",
  financeiro: "Financeiro",
};
export const topicLabel = (k) => (k ? TOPICS[k] || k : "Não classificado");
